import { relativeDayLabel } from '@nossorachao/utils';
import { BellOff, CheckCheck } from 'lucide-react';

import { PageHeader } from '@/components/layout';
import { Button, Card, EmptyState, Skeleton, cx } from '@/components/ui';
import { useMarkAllRead, useNotifications } from '@/lib/queries';

export function NotificationsPage() {
  const { data, isLoading } = useNotifications();
  const markAll = useMarkAllRead();

  const hasUnread = data?.data.some((notification) => notification.readAt === null) ?? false;

  return (
    <>
      <PageHeader
        title="Notificações"
        action={
          hasUnread ? (
            <Button
              variant="secondary"
              icon={CheckCheck}
              loading={markAll.isPending}
              onClick={() => markAll.mutate()}
            >
              Marcar todas como lidas
            </Button>
          ) : null
        }
      />

      {isLoading ? (
        <Skeleton className="h-40 w-full" />
      ) : !data?.data.length ? (
        <Card>
          <EmptyState
            icon={BellOff}
            title="Nenhuma notificação"
            description="Avisos de pelada, times e mensalidade aparecem aqui."
          />
        </Card>
      ) : (
        <Card className="p-0">
          <ul className="divide-y divide-line">
            {data.data.map((notification) => (
              <li
                key={notification.id}
                className={cx('p-4', notification.readAt === null && 'bg-brand-soft')}
              >
                <div className="flex items-start justify-between gap-4">
                  <div className="min-w-0">
                    <p className="font-semibold">{notification.title}</p>
                    <p className="mt-0.5 text-[13px] text-ink-2">{notification.body}</p>
                  </div>

                  <span className="shrink-0 text-[13px] text-ink-3">
                    {relativeDayLabel(new Date(notification.createdAt))}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </>
  );
}
